export const PATIENT_TAB_PARAM = 'tab';

export function patientTabIds(clinical: boolean, billing: boolean, insurance: boolean): string[] {
  return [...(clinical ? ['timeline', 'visits'] : []), ...(billing ? ['billing'] : []), ...(insurance ? ['insurance'] : []), 'documents'];
}

export function chosenPatientTab(requested: string | null, available: readonly string[], fallback: string): string {
  return requested && available.includes(requested) ? requested : fallback;
}

export function withPatientTab(current: URLSearchParams, tab: string, fallback: string): URLSearchParams {
  const next = new URLSearchParams(current);
  if (tab === fallback) next.delete(PATIENT_TAB_PARAM);
  else next.set(PATIENT_TAB_PARAM, tab);
  return next;
}

export function patientTabPath(patientId: string, tab: string): string {
  return `/patients/${encodeURIComponent(patientId)}?${PATIENT_TAB_PARAM}=${encodeURIComponent(tab)}`;
}
